import { isSet, Unset } from '@utils/object';

const numberDefaultFormatter = new Intl.NumberFormat(navigator.language, {
  maximumFractionDigits: 3,
  useGrouping: false,
});

export namespace Localize {
  export function formatNumber(
    value: number | Unset,
    unsetSymbol?: string
  ): string {
    return isSet(value)
      ? numberDefaultFormatter.format(value)
      : unsetSymbol ?? '';
  }
}
